
export default function PointGuide() {
  const spuItems = [
    { service: 'ECモール系カード', point: '+2倍', description: 'ECモールでのお買い物' },
    { service: 'モバイルサービス', point: '+4倍', description: '最強プラン契約' },
    { service: '提携銀行', point: '+0.5倍', description: 'カード引き落とし口座設定' },
    { service: '証券サービス', point: '+0.5倍', description: '投資信託の購入' },
    { service: '光回線サービス', point: '+1倍', description: '光回線契約' },
    { service: 'トラベルサービス', point: '+1倍', description: '対象サービス利用' },
  ];

  const usePoints = [
    {
      icon: 'ri-shopping-bag-line',
      title: 'ECモール',
      description: '1ポイント＝1円として利用可能',
    },
    {
      icon: 'ri-store-line',
      title: '街のお店',
      description: 'マクドナルド、ファミマ、すき家など',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'スマホ決済',
      description: 'コンビニ・ドラッグストアなど',
    },
    {
      icon: 'ri-funds-box-line',
      title: '証券サービス',
      description: 'ポイントで投資信託を購入',
    },
    {
      icon: 'ri-plane-line',
      title: 'トラベルサービス',
      description: '旅行代金の支払いに',
    },
    {
      icon: 'ri-phone-line',
      title: 'モバイルサービス',
      description: '月々の料金支払いに',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#333333] mb-3 text-center">
          ポイントの貯め方・使い方
        </h2>
        <p className="text-gray-600 text-center mb-12">SPUを活用してポイントを最大化しよう</p>

        <div className="mb-12">
          <h3 className="text-xl font-bold text-[#333333] mb-6 flex items-center gap-2">
            <i className="ri-arrow-up-circle-fill text-[#BF0000] text-2xl"></i>
            SPU（スーパーポイントアッププログラム）
          </h3>
          <div className="bg-gradient-to-r from-[#FFF5F5] to-[#FFF0F0] rounded-xl p-6">
            <p className="text-gray-700 text-sm mb-6">
              グループのサービスを使えば使うほど、ECモールでのポイント還元率がアップ！
            </p>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {spuItems.map((item, index) => (
                <div key={index} className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-[#333333] font-bold text-sm">{item.service}</span>
                    <span className="bg-[#BF0000] text-white text-xs font-bold px-2 py-1 rounded">
                      {item.point}
                    </span>
                  </div>
                  <p className="text-gray-600 text-xs">{item.description}</p>
                </div>
              ))}
            </div>
            <div className="mt-6 bg-white rounded-lg p-4 border-2 border-[#BF0000]">
              <p className="text-center text-[#333333] font-bold">
                <span className="text-[#BF0000] text-2xl">最大16倍以上</span>
                <span className="text-sm ml-2">のポイント還元も可能！</span>
              </p>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-xl font-bold text-[#333333] mb-6 flex items-center gap-2">
            <i className="ri-gift-fill text-[#BF0000] text-2xl"></i>
            ポイントの使い道
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {usePoints.map((item, index) => (
              <div key={index} className="bg-[#FFF5F5] rounded-xl p-5 hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-[#BF0000] rounded-full mb-3">
                  <i className={`${item.icon} text-white text-xl`}></i>
                </div>
                <h4 className="text-[#333333] font-bold text-base mb-1">{item.title}</h4>
                <p className="text-gray-600 text-sm">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
